import React from 'react';

const SearchGoogleMail = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg"
         width="24"
         height="18"
         viewBox="0 0 24 18"
         fill="none">
      <g clipPath="url(#clip0_30980_445228)">
        <path d="M1.63636 18.0001H5.45455V8.72738L0 4.63647V16.3637C0 17.2692 0.733636 18.0001 1.63636 18.0001Z"
              fill="#4285F4" />
        <path d="M18.5454 18.0001H22.3636C23.269 18.0001 24 17.2665 24 16.3637V4.63647L18.5454 8.72738"
              fill="#34A853" />
        <path d="M18.5454 1.63637V8.72728L24 4.63637V2.45455C24 0.430912 21.69 -0.722724 20.0727 0.490912"
              fill="#FBBC04" />
        <path d="M5.45459 8.72738V1.63647L12 6.54557L18.5455 1.63647V8.72738L12 13.6365" fill="#EA4335" />
        <path d="M0 2.45455V4.63637L5.45455 8.72728V1.63637L3.92727 0.490912C2.30727 -0.722724 0 0.430912 0 2.45455Z"
              fill="#C5221F" />
      </g>
      <defs>
        <clipPath id="clip0_30980_445228">
          <rect width="24" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SearchGoogleMail;
